import classnames from 'classnames/bind';
import { get } from 'lodash';
import { Dotdotdot, TooltipV2 as Tooltip } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './filterValues.module.scss';

const defaultMinVisibleCount = 1;
const classNameBuilder = classnames.bind(styles);

export const FilterValues = props => {
    const { values, typeLabel, minVisibleCount = defaultMinVisibleCount } = props;
    const filerLabels = values.map(value => get(value, 'label'));
    const joinedVisibleLabels = filerLabels.slice(0, minVisibleCount).join(', ');
    const firstValue = (
        <Dotdotdot lines={1} tagName="span" className={classNameBuilder('dot-value-container')}>
            {joinedVisibleLabels}
        </Dotdotdot>
    );
    if (values.length > minVisibleCount) {
        const joinedLabels = filerLabels.join(', ');
        const suffix = (
            <span>
                <Tooltip arrow interactive>
                    {joinedLabels}
                </Tooltip>
                <FormattedMessage
                    id="app.campaigns.reports.filters.comparable.closed.label.suffix"
                    values={{ count: values.length - minVisibleCount }}
                    defaultMessage=" and {count} more"
                />
            </span>
        );
        return (
            <FormattedMessage
                className={classNameBuilder('filter-value-container')}
                id="app.campaigns.reports.filters.comparable.closed.label.withSuffix"
                values={{ type: typeLabel, values: firstValue, suffix }}
                defaultMessage="{type}: {values} {suffix}"
            />
        );
    }
    return (
        <span className={classNameBuilder('filter-single-value-container')}>
            <FormattedMessage
                className={classNameBuilder('filter-single-value')}
                id="app.campaigns.reports.filters.closed.label"
                values={{
                    type: typeLabel,
                    values: firstValue,
                }}
                defaultMessage="{type}: {values}"
            />
        </span>
    );
};
